import { defineBlock, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Myths vs Facts",
  tags: ["root"],
  conditions: {
    postTypes: ["page"],
  },
}

export default defineBlock("myths-vs-facts/myths-vs-facts", (props) => {
  return (
    <InnerBlocks
      template={[
        ["content/subpage-hero", null],
        ["myths-vs-facts/items", null],
        ["home/stats", null],
      ]}
      templateLock="all"
      orientation="vertical"
    />
  )
})
